export const CURRENCY = {
  pt: "€",
  uk: "£",
  es: "€",
};

export const PRICES = {
  pt: {
    basic: {
      month: 0,
      semester: 0,
      year: 0,
    },
    professional: {
      month: 25,
      semester: 120,
      year: 180,
    },
    professionalPlus: {
      month: 35,
      semester: 180,
      year: 300,
    },
    enterprise: {
      month: 100,
      semester: 450,
      year: 600,
    },
  },
  uk: {
    basic: {
      month: 0,
      semester: 0,
      year: 0,
    },
    professional: {
      month: 35, // 25€ -> 35€
      semester: 180, // 120/6 = 20€/m -> 30€ * 6 = 180€
      year: 300, // 180/12 = 15€ -> 20€ = 20€/month * 12 = 240€
    },
    professionalPlus: {
      month: 50, // 35€ -> 50€ = 50€/month
      semester: 255, // 180/6 = 30€ -> 40€ = 40€/month * 6 = 240€
      year: 420, // 300/12 = 25€ -> 30€ = 30€/month * 12 = 360€
    },
    enterprise: {
      month: 125, // 25 €/m * 5 = 125 €
      semester: 600, // 900/6 = 150€ (5 users) / 5 = 30€/m -> 20€ = 20€/month * 6 * 5 = 600€
      year: 1000, // 600/12 = 50€ (5 users) / 5 = 10€/m -> 15€ = 15€/month * 12 * 5 = 900€
    },
  },
  es: {
    basic: {
      month: 0,
      semester: 0,
      year: 0,
    },
    professional: {
      month: 35, // 25€ -> 35€
      semester: 180, // 120/6 = 20€/m -> 30€ * 6 = 180€
      year: 300, // 180/12 = 15€ -> 25€ = 25€/month * 12 = 300€
    },
    professionalPlus: {
      month: 50,
      semester: 255,
      year: 420,
    },
    enterprise: {
      month: 125, // 25 €/m * 5 = 125 €
      semester: 600, // 900/6 = 150€ (5 users) / 5 = 30€/m -> 20€ = 20€/month * 6 * 5 = 600€
      year: 1000, // 600/12 = 50€ (5 users) / 5 = 10€/m -> 15€ = 15€/month * 12 * 5 = 900€
    },
  },
};

export const MIN_USER_PRICES = {
  // for enterprise users
  pt: {
    month: {
      users: "5",
      price: "+20€/m px)",
    },
    semester: {
      users: "5",
      price: "+90€/px(~15€/m)",
    },
    year: {
      users: "5",
      price: "+120€/px(~10€/m)",
    },
  },
  uk: {
    month: {
      users: "5",
      price: "+25£/m px",
    },
    semester: {
      users: "5",
      price: "+120£/px(~20£/m)",
    },
    year: {
      users: "5",
      price: "+200£/px(~17£/m)",
    },
  },
  es: {
    month: {
      users: "5",
      price: "+25€/m px",
    },
    semester: {
      users: "5",
      price: "+120€/px(~20€/m)",
    },
    year: {
      users: "5",
      price: "+200€/px(~17€/m)",
    },
  },
};

export const LEADS_PRICING = {
  pt: {
    leads: "1000€ setup fee +300€/m",
    website: "490€",
  },
  uk: {
    leads: "2000£ setup fee +500£/m",
    website: "760£",
  },
  es: {
    leads: "2000€ setup fee +500€/m",
    website: "760€",
  },
};

export const getInitialData = (origin, copy) => [
  {
    id: "numberOfAccounts",
    name: copy.numberOfAccounts,
    description: null,
    basic: "1",
    professional: "1",
    professionalPlus: "1",
    enterprise: "5",
  },
  {
    id: "extraAccount",
    name: copy.extraAccount,
    description: null,
    basic: false,
    professional: false,
    professionalPlus: false,
    enterprise: MIN_USER_PRICES[origin].year.price,
  },
  {
    id: "coverage",
    name: copy.coverage.name,
    description: null,
    basic: copy.coverage.all,
    professional: copy.coverage.all,
    professionalPlus: copy.coverage.all,
    enterprise: copy.coverage.all,
  },
  {
    id: "responsive",
    name: copy.responsive,
    description: null,
    basic: true,
    professional: true,
    professionalPlus: true,
    enterprise: true,
  },
  {
    id: "multiLang",
    name: copy.multiLang,
    description: null,
    basic: true,
    professional: true,
    professionalPlus: true,
    enterprise: true,
  },
  {
    id: "avm",
    name: copy.avm.name,
    description: copy.avm.desc,
    basic: copy.avm.basic,
    professional: copy.avm.pro,
    professionalPlus: copy.avm.proPlus,
    enterprise: copy.avm.ent,
  },
  {
    id: "marketReports",
    name: copy.marketReports.name,
    description: copy.marketReports.desc,
    basic: true,
    professional: true,
    professionalPlus: true,
    enterprise: true,
    open: false,
    collapse: [
      {
        id: "numberOfReport",
        name: copy.marketReports.numberOfReport.name,
        description: null,
        basic: copy.marketReports.numberOfReport.basic,
        professional: copy.marketReports.numberOfReport.pro,
        professionalPlus: copy.marketReports.numberOfReport.proPlus,
        enterprise: copy.marketReports.numberOfReport.ent,
      },
      {
        id: "priceInterval",
        name: copy.marketReports.priceInterval,
        description: null,
        basic: true,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "rentYieldInterval",
        name: copy.marketReports.rentYieldInterval,
        description: null,
        basic: true,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "updateReport",
        name: copy.marketReports.updateReport,
        description: null,
        basic: true,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "shareReport",
        name: copy.marketReports.shareReport,
        description: null,
        basic: true,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "printExport",
        name: copy.marketReports.printExport,
        description: null,
        basic: true,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "comments",
        name: copy.marketReports.comments,
        description: null,
        basic: true,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "imageUpload",
        name: copy.marketReports.imageUpload,
        description: null,
        basic: true,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "similarProperties",
        name: copy.marketReports.similarProperties,
        description: null,
        basic: true,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "editProperties",
        name: copy.marketReports.editProperties,
        description: null,
        basic: true,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "pointsOfInterest",
        name: copy.marketReports.pointsOfInterest,
        description: null,
        basic: true,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },

      {
        id: "customExtraCharacteristics",
        name: copy.marketReports.customExtraCharacteristics,
        description: null,
        basic: false,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "customStatus",
        name: copy.marketReports.customStatus.name,
        description: copy.marketReports.customStatus.desc,
        basic: false,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "customReportPrice",
        name: copy.marketReports.customReportPrice,
        description: null,
        basic: false,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "priceIntervalConfidenceLevel",
        name: copy.marketReports.priceIntervalConfidenceLevel,
        description: null,
        basic: false,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "transactionalData",
        name: copy.marketReports.transactionalData.name,
        description: copy.marketReports.transactionalData.desc,
        basic: false,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "comparableProperties",
        name: copy.marketReports.comparableProperties.name,
        description: null,
        basic: copy.marketReports.comparableProperties.basic,
        professional: copy.marketReports.comparableProperties.pro,
        professionalPlus: copy.marketReports.comparableProperties.proPlus,
        enterprise: copy.marketReports.comparableProperties.ent,
      },
      {
        id: "customInterval",
        name: copy.marketReports.customInterval,
        description: null,
        basic: false,
        professional: false,
        professionalPlus: false,
        enterprise: true,
      },
      {
        id: "customReportLogo",
        name: copy.marketReports.customReportLogo,
        description: null,
        basic: false,
        professional: false,
        professionalPlus: false,
        enterprise: true,
      },
    ],
  },
  {
    id: "prospection",
    name: copy.prospection.name,
    description: copy.prospection.desc,
    basic: false,
    professional: true,
    professionalPlus: true,
    enterprise: true,
    open: false,
    collapse: [
      {
        id: "searchBy",
        name: copy.prospection.searchBy.name,
        description: copy.prospection.searchBy.desc,
        basic: false,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "countryWide",
        name: copy.prospection.countryWide.name,
        description: copy.prospection.countryWide.desc,
        basic: false,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "listed",
        name: copy.prospection.listed,
        description: null,
        basic: false,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "filterByDetails",
        name: copy.prospection.filterByDetails,
        description: null,
        basic: false,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "filterFSBO",
        name: copy.prospection.filterFSBO,
        description: null,
        basic: false,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "filterByExclusive",
        name: copy.prospection.filterByExclusive,
        description: null,
        basic: false,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "mapSearch",
        name: copy.prospection.mapSearch,
        description: null,
        basic: false,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "liveListings",
        name: copy.prospection.liveListings,
        description: null,
        basic: false,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "alerts",
        name: copy.prospection.alerts,
        description: null,
        basic: false,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "collections",
        name: copy.prospection.collections,
        description: null,
        basic: false,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
    ],
  },
  {
    id: "portfolio",
    name: copy.portfolio.name,
    description: copy.portfolio.desc,
    basic: true,
    professional: copy.portfolio.pro,
    professionalPlus: copy.portfolio.proPlus,
    enterprise: copy.portfolio.ent,
    open: false,
    collapse: [
      {
        id: "customPortfolio",
        name: copy.portfolio.customPortfolio,
        description: null,
        basic: true,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "transactionHistory",
        name: copy.portfolio.transactionHistory.name,
        description: copy.portfolio.transactionHistory.desc,
        basic: true,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "referredAssets",
        name: copy.portfolio.referredAssets.name,
        description: copy.portfolio.referredAssets.desc,
        basic: true,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "testimonials",
        name: copy.portfolio.testimonials.name,
        description: copy.portfolio.testimonials.desc,
        basic: true,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "blog",
        name: copy.portfolio.blog.name,
        description: copy.portfolio.blog.desc,
        basic: true,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "contactForm",
        name: copy.portfolio.contactForm,
        description: null,
        basic: true,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "responsive",
        name: copy.portfolio.portfolioResponsive,
        description: null,
        basic: true,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "multiLang",
        name: copy.portfolio.portfolioMultiLang,
        description: null,
        basic: true,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "freeSSL",
        name: copy.portfolio.freeSSL,
        description: null,
        basic: true,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "bandwidth",
        name: copy.portfolio.bandwidth.name,
        description: null,
        basic: copy.portfolio.bandwidth.pro,
        professional: copy.portfolio.bandwidth.pro,
        professionalPlus: copy.portfolio.bandwidth.proPlus,
        enterprise: copy.portfolio.bandwidth.ent,
      },
      {
        id: "seoAnalytics",
        name: copy.portfolio.seoAnalytics,
        description: null,
        basic: true,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
    ],
  },
  {
    id: "insights",
    name: copy.insights.name,
    description: copy.insights.desc,
    basic: copy.insights.basic,
    professional: copy.insights.pro,
    professionalPlus: copy.insights.proPlus,
    enterprise: copy.insights.ent,
    collapse: [
      {
        id: "searchBy",
        name: copy.prospection.searchBy.name,
        description: copy.prospection.searchBy.desc,
        basic: false,
        professional: false,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "mapSearch",
        name: copy.prospection.mapSearch,
        description: null,
        basic: false,
        professional: false,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "countryWide",
        name: copy.prospection.countryWide.name,
        description: copy.prospection.countryWide.desc,
        basic: false,
        professional: false,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "filterByDetails",
        name: copy.prospection.filterByDetails,
        description: null,
        basic: false,
        professional: false,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "filterFSBO",
        name: copy.prospection.filterFSBO,
        description: null,
        basic: false,
        professional: false,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "filterByExclusive",
        name: copy.prospection.filterByExclusive,
        description: null,
        basic: false,
        professional: false,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "indicators",
        name: copy.marketInsights.indicators.name,
        description: copy.marketInsights.indicators.desc,
        basic: false,
        professional: false,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "distributions",
        name: copy.marketInsights.distributions.name,
        description: copy.marketInsights.distributions.desc,
        basic: false,
        professional: false,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "timeSeries",
        name: copy.marketInsights.timeSeries.name,
        description: copy.marketInsights.timeSeries.desc,
        basic: false,
        professional: false,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "agencyMarketShare",
        name: copy.marketInsights.agencyMarketShare.name,
        description: copy.marketInsights.agencyMarketShare.desc,
        basic: false,
        professional: false,
        professionalPlus: true,
        enterprise: true,
      },
    ],
  },
  {
    id: "admin",
    name: copy.admin.name,
    description: null,
    basic: false,
    professional: false,
    professionalPlus: false,
    enterprise: true,
    open: false,
    collapse: [
      {
        id: "overview",
        name: copy.admin.overview.name,
        description: copy.admin.overview.desc,
        basic: false,
        professional: false,
        professionalPlus: false,
        enterprise: true,
      },
      {
        id: "userRanking",
        name: copy.admin.userRanking,
        description: null,
        basic: false,
        professional: false,
        professionalPlus: false,
        enterprise: true,
      },
      {
        id: "manageAccounts",
        name: copy.admin.manageAccounts.name,
        description: copy.admin.manageAccounts.desc,
        basic: false,
        professional: false,
        professionalPlus: false,
        enterprise: true,
      },
      {
        id: "mandageCompanies",
        name: copy.admin.mandageCompanies.name,
        description: copy.admin.mandageCompanies.desc,
        basic: false,
        professional: false,
        professionalPlus: false,
        enterprise: true,
      },
    ],
  },
  {
    id: "customBranding",
    name: copy.customBranding.name,
    description: copy.customBranding.desc,
    basic: false,
    professional: false,
    professionalPlus: false,
    enterprise: true,
  },
];

export const getInitialDataLeads = (origin, copy) => [
  {
    id: "landingPage",
    name: copy.landingPage.name,
    description: copy.landingPage.desc,
    basic: false,
    professional: false,
    professionalPlus: false,
    enterprise: LEADS_PRICING[origin].leads,
    open: false,
    collapse: [
      {
        id: "leadsOverview",
        name: copy.landingPage.leadsOverview.name,
        description: copy.landingPage.leadsOverview.desc,
        basic: false,
        professional: false,
        professionalPlus: false,
        enterprise: true,
      },
      {
        id: "userLandingPage",
        name: copy.landingPage.userLandingPage,
        description: null,
        basic: false,
        professional: false,
        professionalPlus: false,
        enterprise: true,
      },
      {
        id: "companyLandingPage",
        name: copy.landingPage.companyLandingPage,
        description: null,
        basic: false,
        professional: false,
        professionalPlus: false,
        enterprise: true,
      },
      {
        id: "distributeLeads",
        name: copy.landingPage.distributeLeads,
        description: null,
        basic: false,
        professional: false,
        professionalPlus: false,
        enterprise: true,
      },
    ],
  },
  {
    id: "site",
    name: copy.site.name,
    description: copy.site.desc,
    basic: LEADS_PRICING[origin].website,
    professional: LEADS_PRICING[origin].website,
    professionalPlus: LEADS_PRICING[origin].website,
    enterprise: LEADS_PRICING[origin].website,
    open: false,
    collapse: [
      {
        id: "basicFeatures",
        name: copy.site.basicFeatures,
        description: null,
        basic: false,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "logo",
        name: copy.site.logo,
        description: null,
        basic: false,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "domain",
        name: copy.site.domain,
        description: null,
        basic: false,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
      {
        id: "leads",
        name: copy.site.leads,
        description: null,
        basic: false,
        professional: true,
        professionalPlus: true,
        enterprise: true,
      },
    ],
  },
];
